export * from './src/portfolio-collections-v1-collection-collections.meta.js';
